import React from 'react';
import ReactDOM from 'react-dom';

import './polyfill';
import './index.css';
import App from './App';
// disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';

import { store } from './_helpers';

import { Provider } from 'react-redux';

ReactDOM.render((
  <Provider store={store}>
    <App />
  </Provider>
), document.getElementById('root'));

// disable ServiceWorker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js